// extracted by mini-css-extract-plugin
module.exports = {"content":"RBBLi","information":"iHo0i","title":"_5baCj","info":"_2qB8E","divider":"_7zCH7"};